import '../App.css';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

function DeclarationAccessibilite() {
  return (
    <>
      <Helmet>
        <title>Déclaration d'accessibilité | AbbVie Vraie Vie</title>
        <meta
          name="description"
          content="Portail ATU, RTU, Etudes"
        />
      </Helmet>
      <div className='medium-container'>
        <h1>Déclaration d'accessibilité</h1>
        <p>L'accessibilité numérique consiste à rendre les services de communication au public en ligne accessibles aux personnes handicapées, c'est-à-dire perceptibles, utilisables, compréhensibles et robustes.</p>
        <p>Abbvie s'engage à rendre ses sites Web (internet, intranet et extranet), ses progiciels et ses applications mobiles accessibles conformément à l'article 47 de la loi n°2005-102 du 11 février 2005.</p>
        <p>Cette déclaration d'accessibilité s'applique à <Link to={"/"}>AbbVie Vraie Vie</Link>.</p>
        <p>Nous nous engageons à faire en sorte que les sites Web d'AbbVie soient accessibles à tous les utilisateurs, y compris ceux qui utilisent des technologies d'assistance telles que des lecteurs d'écran. Nos sites Web sont régulièrement mis à jour et nos efforts pour garantir l'accessibilité et améliorer l'expérience utilisateur se poursuivent. Si vous rencontrez des difficultés pour accéder à une partie de nos sites Web ou si vous souhaitez nous faire part de vos commentaires sur la facilité d'utilisation de nos sites Web, veuillez nous contacter en utilisant l'une des méthodes de contact ci-dessous. Nous examinerons vos commentaires au fur et à mesure évaluer les moyens d'améliorer l'expérience utilisateur et de répondre aux besoins de tous les visiteurs de notre site Web et de communiquer efficacement avec eux.</p>
        <h2>Etat de conformité</h2>
        <p><Link to={"/"}>AbbVie Vraie Vie</Link> est partiellement conforme avec le référentiel général d'amélioration de l'accessibilité.</p>
        <h2>Résultat des tests</h2>
        <p>L'audit de conformité réalisé en interne révèle que :</p>
        <ul>
          <li>94,9% des critères RGAA sont respectés.</li>
        </ul>
        <h2>Établissement de cette déclaration d'accessibilité</h2>
        <p>Cette déclaration a été établie le 26 juin 2025. Elle a été mise à jour le 26 juin 2025.</p>
        <h2>Mesures visant à favoriser l'accessibilité</h2>
        <p>AbbVie Inc. prend les mesures suivantes pour garantir l'accessibilité de ses sites Web :</p>
        <ul>
          <li>Inclure l'accessibilité dans nos politiques internes.</li>
          <li>Nommez un responsable de l'accessibilité et/ou un médiateur.</li>
          <li>Réaliser régulièrement des audits complets visant à détecter les domaines à améliorer.</li>
        </ul>
        <h2>Spécifications techniques</h2>
        <p>L'accessibilité de nos sites Web repose sur les technologies suivantes pour fonctionner avec la combinaison particulière du navigateur Web et de toutes les technologies d'assistance ou plugins installés sur votre ordinateur :</p>
        <ul>
          <li>HTML</li>
          <li>WAI-ARIA</li>
          <li>CSS</li>
          <li>JavaScript</li>
        </ul>
        <p>Ces technologies sont utilisées pour se conformer aux normes d'accessibilité utilisées.</p>
        <h2>Les outils utilisés lors de l'évaluation</h2>
        <ul>
          <li>Siteimprove</li>
        </ul>
        <h2>Retour d'information et contact</h2>
        <p>Vos commentaires sur l'accessibilité d'AbbVie.com et des autres sites Web d'AbbVie sont les bienvenus. Si vous rencontrez des problèmes d'accessibilité sur un site Web d'AbbVie ou si vous avez une suggestion pour améliorer l'accessibilité ou la convivialité d'un site Web, veuillez nous contacter en utilisant l'une des méthodes ci-dessous. Assurez-vous de faire référence au site Web concerné et de décrire la fonctionnalité spécifique qui, selon vous, n'est pas entièrement accessible ou de suggérer une amélioration :</p>
        <ul>
          <li><Link to={"https://www.abbvie.com/contactus.html"} target="_blank">Formulaire de contact</Link></li>
          <li>Adresse électronique : <Link to={"mailto:webaccessibility@abbvie.com"} target="_blank">webaccessibility@abbvie.com</Link></li>
          <li>Adresse postale : 1 North Waukegan Road, North Chicago, IL, 60064</li>
        </ul>
        <h2>Voies de recours</h2>
        <p>Cette procédure est à utiliser dans le cas suivant.</p>
        <p>Vous avez signalé au responsable du site internet un défaut d'accessibilité qui vous empêche d'accéder à un contenu ou à un des services du portail et vous n'avez pas obtenu de réponse satisfaisante.</p>
        <ul>
          <li>Écrire un message au <Link to={"https://formulaire.defenseurdesdroits.fr/formulaire_saisine/"} target="_blank">Défenseur des droits</Link></li>
          <li>Contacter le délégué du <Link to={"https://www.defenseurdesdroits.fr/carte-des-delegues"} target="_blank">Défenseur des Droits</Link> dans votre région</li>
          <li>Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) : <br/> Défenseur des droits <br/> Libre réponse 71120 <br/> 75342 Paris CEDEX 07</li>
        </ul>
      </div>
    </>
  )
}

export default DeclarationAccessibilite;
